const RECEIVE_OMNI_RETAILER_CONTENT_DATA =
  'src/omni/omniRetailerContentScoreConfigure/RECEIVE_OMNI_RETAILER_CONTENT_DATA' as const;
const START_FETCH = 'src/omniRetailerContentScoreConfigure/START_FETCH' as const;
const END_FETCH = 'src/omniRetailerContentScoreConfigure/END_FETCH' as const;

export default { RECEIVE_OMNI_RETAILER_CONTENT_DATA, START_FETCH, END_FETCH };
